import { useEffect, useState } from "react";
import { getAllGroup } from "./customerGroupingApi";
import {
  Box,
  Button,
  Card,
  CardContent,
  Fab,
  Grid,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import UserCard from "../../common/searchModal/userCard";
import AddCategories from "./addGropmodal";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { useSelector } from "react-redux";

export const GroupingCustomer = () => {
  const [open, setOpen] = useState(false);
  const userDetail = useSelector((state) => state.reducer.userDetail);

  const [collection, setCollection] = useState([]);
  useEffect(() => {
    console.log("userDetailcustomergroup", userDetail);
    // if (userDetail?.appMenu) {
      getAllGroup((data) => {
        // console.loguser-profile-list("groupalldata", data);

        setCollection(data?.data?.list);
      });
    // }
  }, [userDetail]);
  return (
    <Box
      sx={{
        py: "17px",
        px: { xs: "10px", sm: "30px" },
        background: "#ede9ff",
        minHeight: "100vh",
      }}
    >
      <Grid container alignItems="center" spacing={2}>
        {/* <DynamicBreadcrumbs /> */}
        <Grid item xs={12} lg={9} sm={8} sx={{}}>
          <Box
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px",
              paddingLeft: "20px",
              borderRadius: 2,
              color: "#01008B", // optional text color
              textAlign: "left",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: {
                  xs: "12px",
                  sm: "13px",
                  md: "15px",
                },
              }}
            >
              Customer Groups
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} lg={3} sm={4}>
          <Button
            variant="contained"
            fullWidth
            onClick={() => {
              setOpen(true);
            }}
            sx={{
              height: "40px",
              backgroundColor: "#14008B",
              padding: "0px",
              fontSize: {
                xs: "12px",
                sm: "13px",
                md: "15px",
              },
            }}
            endIcon={<AddIcon />}
          >
            Add Customer Groups
          </Button>
        </Grid>

        <Grid item xs={12} sx={{}}>
          <Grid
            container
            sx={{
              backgroundColor: "#fff",
              padding: "10px",
              borderRadius: "10px",
              height: "70vh",
              overflowY: "auto",
            }}
          >
            <Grid item xs={12}>
              <Grid container>
                {collection.map((ele, index) => {
                  return (
                    <Grid item xs={12} sm={6}>
                      <Card
                        key={"customerGroup" + index}
                        sx={{
                          boxShadow: "0 4px 2.3px 0 #00000026",
                          m: "3px",
                          p: "10px 20px",
                          backgroundColor: "#EEEEFF",
                          // cursor: "pointer",
                        }}
                        // onClick={() => { setOpen(true) }}
                      >
                        <CardContent sx={{ p: "0px 10px !important" }}>
                          <Grid container>
                            <Grid item xs={6}>
                              <Typography
                                component="span"
                                sx={{
                                  fontFamily: "'Montserrat', sans-serif",
                                  fontWeight: 500,
                                  fontSize: {
                                    xs: "10px",
                                    sm: "13px",
                                    md: "15px",
                                  },
                                  color: "#000000",
                                }}
                              >
                                Group Name
                              </Typography>
                            </Grid>
                            <Grid item xs={6}>
                              <Typography
                                component="span"
                                sx={{
                                  fontFamily: "'Montserrat', sans-serif",
                                  fontWeight: 600,
                                  color: "primary.main",
                                  fontSize: {
                                    xs: "10px",
                                    sm: "13px",
                                    md: "15px",
                                  },
                                }}
                              >
                                {ele.customerGroupName}
                              </Typography>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <AddCategories
          open={open}
          setOpen={setOpen}
          callback={() =>
            getAllGroup((data) => {
              setCollection(data?.data?.list);
            })
          }
        />
      </Grid>
    </Box>
  );
};
